export const PRODUCT_VIEWED = 'product:viewed'
export const PRODUCT_ACTIVE_VARIANT_VIEWED = 'product-active-variant:viewed'
export const PRODUCT_CARD_CLICKED = 'product-card:clicked'
